import apiDietPaymentProcessor from "./apiDietPaymentProcessor"

// Brand-specific upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({ offerPath, paymentsPath, paymentsFailPath, paymentsSuccessPath, sendOffPath } = {}) => ({
    // Init common upsell functionality

    ...commonUpsell({
      upsellOfferType: "shopping_list",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      sendOffPath,
    }),

    isPaymodeModalNeeded: false,
    isPaymodeModalOpen: false,
    chosenPaymentMethod: null,

    init() {
      this.commonInitUpsell()

      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.isLoading = false
          this.chosenPaymentMethod = null
        }
      })

      if (
        !this.store.values.lastPaymentMethod ||
        this.store.values.lastPaymentMethod !== "primer" ||
        !this.store.values.isCardSaved
      ) {
        this.isPaymodeModalNeeded = true
      }
    },

    handlePayment(paymode) {
      const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

      // Handle card-save payments
      if (!paymode && !this.isPaymodeModalNeeded) {
        this.isLoading = true
        const paymentParamsCardSave = {
          successStepPath: paymentsSuccessPath,
          failedStepPath: paymentsFailPath,
          paymentMethod: "primer",
          restrictCardSave: false,
          checkoutTemplate: "yg-ac-pipe",
        }

        handleCheckoutAndRedirect(paymentParamsCardSave)
        return
      }
      // Open up modal if there is no paymode
      if (!paymode && this.isPaymodeModalNeeded) {
        this.isPaymodeModalOpen = true

        return
      }

      // Handle payments that doesn't have save-card
      this.store.internalTracker.trackClick({
        clickName: (paymode === "paypal_recurring" ? "PayPal" : "Credit Card") + " Selected"
      })
      
      this.chosenPaymentMethod = paymode
      this.store.values.lastPaymentMethod = paymode
      this.isLoading = true
      const paymentParamsWithoutCardSave = {
        successStepPath: paymentsSuccessPath,
        failedStepPath: paymentsFailPath,
        paymentMethod: paymode,
        restrictCardSave: true,
        checkoutTemplate: "yg-ac-pipe",
      }

      handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
    },

    handleContinue() {
      if (this.store.values.lastPaymentMethod && this.store.values.lastPaymentMethod === "primer") {
        this.store.values.isCardSaved = true
      }

      this.thankYouContinue()
    },

    handleModalClose() {
      this.isPaymodeModalOpen = false
    },

    handleAcceptOffer(paymode) {
      this.trackClickPurchase()

      this.handlePayment(paymode)
    },

    getSpinnerStatus(paymentMethod) {
      if (!this.isLoading) return false
      if (this.chosenPaymentMethod !== paymentMethod) return false

      return true
    },
  })
